'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { LOADING_PROBLEM_AND_MESSAGE } from '../shared/dataProblemsAndMessages';
import { DASHBOARD_PERMISSION_DENIED, IS_READ_ONLY_DEMO_DASHBOARD } from '../problems';
import { useHasDemoDashboardWriteAccess } from '../../access/scopes/hooks/useHasScope';
import { getUserPermissionLevel, getDemo } from '../../data/schemas/dashboardSchema';
import { hasSufficientCreatePermission } from '../../permissions/permission-logic';
import { jsx as _jsx } from "react/jsx-runtime";
const useDeleteDashboardProblem = ({
  dashboard
}) => {
  const isLoading = !dashboard;
  const userCanWriteDemoDashboard = useHasDemoDashboardWriteAccess();
  const isReadOnlyDemo = getDemo(dashboard) && !userCanWriteDemoDashboard;
  const dashboardPermissionDenied = !hasSufficientCreatePermission(getUserPermissionLevel(dashboard));
  if (isLoading) {
    return LOADING_PROBLEM_AND_MESSAGE;
  }
  if (dashboardPermissionDenied) {
    return {
      problem: DASHBOARD_PERMISSION_DENIED,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.deleteDashboard.tooltip.dashboardPermissionDenied"
      })
    };
  }
  if (isReadOnlyDemo) {
    return {
      problem: IS_READ_ONLY_DEMO_DASHBOARD,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.deleteDashboard.tooltip.isReadOnlyDemo"
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useDeleteDashboardProblem;